export const API_ERROR = 'API_ERROR';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_MODAL = 'UPDATE_MODAL';
export const UPDATE_WELCOME_MAT = 'UPDATE_WELCOME_MAT';
export const UPDATE_FORM = 'UPDATE_FORM';
export const OPEN_TOAST = 'OPEN_TOAST';
export const CLOSE_TOAST = 'CLOSE_TOAST';
